// src/models/User.ts - Updated with signup response interface

export const USER_ROLE_ADMIN = 'admin';
export const USER_ROLE_CREATOR = 'creator'
export const USER_ROLE_USER = 'user'

/**
 * Represents a user within the application.
 */
export interface User {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  job_title?: string;
  language_preference: string,
  organization_id: string;
  user_role_id: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface UserWithWorkspace {
  id: string;
  email: string;
  password: string;
  last_name: string;
  first_name: string;
  job_title: string;
  user_role_id: string;
  workspace_role_id: string;
}

export interface UserProfileEdit {
  first_name?: string;
  last_name?: string;
  job_title?: string;
  language_preference?: string
}

/**
 * Represents a UserRole within the application.
 */
export interface UserRole {
  id: string;
  name: string;
}

export interface UserOnboardingInfo {
  email: string;
  first_name: string;
  last_name: string;
  organization_name: string;
  is_expired: boolean;
  language_preference?: string
}

export interface OnboardingData {
  email: string;
  first_name: string;
  last_name: string;
  onboarding_token: string;
  password: string;
  job_title: string;
  language_preference: string;
  terms_accepted: boolean;
}

// Updated signup interfaces to match backend
export interface SignupRequest {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  job_title: string;
  organization_name: string;
  selected_plan: string;
  marketing_emails: boolean;
}

export interface SignupResponse {
  message: string;
  user_id: string;
  organization_id: string;
  // Authentication tokens for automatic login
  access_token: string;
  refresh_token: string;
  expires: number;
  token_type: string;
  // Optional checkout URL for paid plans
  checkout_url?: string;
}

export interface LoginResponse {
  access_token: string;
  refresh_token: string;
  expires: number;
  token_type: string;
}

export interface PasswordResetRequest {
  email: string;
}

export interface SetPasswordRequest {
  token: string;
  password: string;
}